import { permissionAllowed, System, SystemDetails } from "@ews/react-data";
import { useL10n } from "@ews/react-localization-context";

import
{
    useModifySystem,
    useModifySystemDetails,
    useSystem,
    useSystemDetails
} from "../../../ReactData/system";

import { Point, Polygon } from "geojson";
import { useCallback } from "react";
import CustomerTypeAhead from "../../../Customer/CustomerTypeAhead";
import GenericTypeAhead from "../../../GenericTypeAhead/GenericTypeAhead";
import { useMyProfileId } from "../../../Login/LoginProvider";
import { useUserPermissions } from "../../../ReactData/user";
import SettingsCol from "../../../Settings/SettingsCol/SettingsCol";
import SettingsCheckbox from "../../../Settings/SettingsComponents/SettingsCeckbox/SettingsCeckbox";
import SettingsLabel from "../../../Settings/SettingsComponents/SettingsLabel/SettingsLabel";
import SettingsTextInput from "../../../Settings/SettingsComponents/SettingsTextInput/SettingsTextInput";
import { SettingsLanguageTypeAhead } from "../../../Settings/SettingsLanguageTypeAhead/SettingsLanguageTypeAhead";
import { TooltipIcon } from "../../../ToolTip/useTooltip";
import GPSArea from "../../GPSArea/GPSArea";
import { MainSettingsProps } from "./types";

const supportedTimezones = Object.fromEntries(
    Intl.supportedValuesOf('timeZone').map(timeZone => [timeZone, timeZone])
);

supportedTimezones["UTC"] = "UTC";

const MainSettings: React.FC<MainSettingsProps> = ({ systemId }) =>
{
    const system = useSystem(systemId);
    const details = useSystemDetails(systemId);

    const me = useMyProfileId();
    const myPermissions = useUserPermissions(me);
    const allowedToEdit = permissionAllowed(myPermissions.grantSystemAccess || 0);

    const modifySystem = useModifySystem();
    const modifySystemDetails = useModifySystemDetails();

    //const customer = useCustomer(system.customerId || "");
    const { translate: t } = useL10n();

    const saveSystem = useCallback(async (data: System) =>
    {
        await modifySystem(systemId, data);
    }, [modifySystem, systemId]);

    const saveSystemDetails = useCallback(async (data: SystemDetails) =>
    {
        await modifySystemDetails(systemId, data);//
    }, [modifySystemDetails, systemId]);

    return <>
        <SettingsCol >
            <SettingsCheckbox
                disabled={!allowedToEdit}
                text={"COM_BANNERS_HEADING_ACTIVE"}
                checked={system.active}
                onChange={(active) =>
                {
                    saveSystem({ active } as System);
                }} />
            {/*<SettingsLabel
                text="COM_FACPMANAGEMENT_FACP_CUSTOMER_FIELD_PARENT_LABEL"
             tooltip={<TooltipIcon text={t("der Assigned client der Anlage")} />}
                value={systemState.customerId || ''} /> */}
            <CustomerTypeAhead
                label={t('COM_FACPMANAGEMENT_CUSTOMER_FIELD_PARENT_LABEL')}
                id={"Assigned-client"}
                currentId={system.customerId || ""}
                onChange={(customerId => saveSystem({ customerId: customerId || null } as System))}
                disabled={allowedToEdit ? !permissionAllowed(myPermissions.isAdmin!) : true}
            />
            {/*  <SettingsLabel
                text="TD_SERIENNR"
             tooltip={<TooltipIcon text={t("COM_FACPMANAGEMENT_FACP_FIELD_SERIAL_NUMBER_DESC")} />}
                value={details.serialNumber || ''} />
                */}
            <SettingsLabel
                text={"COM_FACPMANAGEMENT_LOGS_MAIL_ANLAGENID"}
                value={`${system.systemNumber || ""}`} />
            <SettingsTextInput
                disabled={!allowedToEdit}
                text={"COM_FACPMANAGEMENT_FACP_FIELD_FACP_NAME1_LABEL"}
                required
                inputType={"text"}
                value={system.name || ''}
                onChange={(value) =>
                {
                    if (system.name === value) return;
                    saveSystem({ "name": value } as System);
                }
                } />

            <SettingsTextInput
                disabled={!allowedToEdit}
                text={"COM_FACPMANAGEMENT_FACP_FIELD_FACP_ALIAS_LABEL"}

                inputType={"text"}
                value={system.alias || ''}
                onChange={(value) =>
                {
                    if (system.name === value) return;
                    saveSystem({ "alias": value } as System);
                }
                } />


            <SettingsTextInput
                disabled={!allowedToEdit}
                text={"COM_FACPMANAGEMENT_FACP_FIELD_FACP_LOCATION1_LABEL"}

                inputType={"text"}
                value={details.location || ''}
                onChange={(value) =>
                {
                    if (details.location === value) return;
                    saveSystemDetails({ "location": value } as SystemDetails);
                }} />
            <SettingsTextInput
                disabled={!allowedToEdit}
                text={"COM_FACPMANAGEMENT_FACP_FIELD_FACP_LOCATION2_LABEL"}

                inputType={"text"}
                value={details.site || ''}
                onChange={(value) =>
                {
                    if (details.site === value) return;
                    saveSystemDetails({ "site": value } as SystemDetails);
                }} />
            <SettingsTextInput
                disabled={!allowedToEdit}
                text={"COM_FACPMANAGEMENT_FACP_FIELD_FACP_ADDRESS1_LABEL"}
                value={details.street || ''}
                onChange={(value) =>
                {
                    if (details.street === value) return;
                    saveSystemDetails({ "street": value } as SystemDetails);
                }} />
            <SettingsTextInput
                disabled={!allowedToEdit}
                text={"COM_FACPMANAGEMENT_FACP_FIELD_FACP_ADDRESS2_LABEL"}
                value={details.street2 || ''}
                onChange={(value) =>
                {
                    if (details.street2 === value) return;
                    saveSystemDetails({ "street2": value } as SystemDetails);
                }} />
            <SettingsTextInput
                disabled={!allowedToEdit}
                text={"COM_FACPMANAGEMENT_CUSTOMERS_POSTAL_CODE"}
                tooltip={<TooltipIcon text={t("COM_FACPMANAGEMENT_FACP_FIELD_POSTAL_CODE_DESC")} />}
                inputType={"text"}
                value={details.zip || ''}
                onChange={(value) =>
                {
                    if (details.zip === value) return;
                    saveSystemDetails({ "zip": value } as SystemDetails);
                }} />
            <SettingsTextInput
                disabled={!allowedToEdit}
                text={"PLG_USER_PROFILE_FIELD_CITY_LABEL"}
                tooltip={<TooltipIcon text={t("COM_FACPMANAGEMENT_FACP_FIELD_CITY_DESC")} />}
                inputType={"text"}
                value={details.city || ''}
                onChange={(value) =>
                {
                    if (details.city === value) return;
                    saveSystemDetails({ "city": value } as SystemDetails);
                }
                } />

            <SettingsLanguageTypeAhead
                disabled={!allowedToEdit}
                id="languageSystemSetting"
                value={details.country}
                onChange={(data) =>
                {
                    const { alpha3 } = data;
                    saveSystemDetails({ "country": alpha3 } as SystemDetails);
                }}
            />

            <GenericTypeAhead
                useOffsetY
                disabled={!allowedToEdit}
                label="COM_ADMIN_USER_FIELD_TIMEZONE_LABEL"
                current={details.timezone}
                list={supportedTimezones}
                onChange={function (id: string | null): void
                {
                    if (id) saveSystemDetails({ "timezone": supportedTimezones[id] } as SystemDetails);
                }
                } />
            {/* <SettingsCheckbox
                disabled={!allowedToEdit}
                text={"COM_FACPMANAGEMENT_FACP_SUMMERTIME"}
                checked={details.dayLightSaving}
                onChange={(val) => saveSystemDetails({ "dayLightSaving": val } as SystemDetails)} /> */}
        </SettingsCol>
        <SettingsCol lg={'6'} xl={'8'}>

            <SettingsCheckbox
                disabled={!allowedToEdit}
                text={"COM_FACPMANAGEMENT_FACP_FIELD_SENDGPSTOUSERACL2_LABEL"}
                tooltip={<TooltipIcon text={t("COM_FACPMANAGEMENT_FACP_FIELD_SENDGPSTOUSERACL2_DESC")} />}
                checked={details.exposeGPS || false}
                onChange={(exposeGPS) =>
                {
                    saveSystemDetails({ "exposeGPS": exposeGPS } as SystemDetails);
                }} />

            {permissionAllowed(myPermissions.grantSystemAccess || 0) ?
                <GPSArea
                    area={details.GPSArea as Polygon}
                    position={details.GPSPosition as Point}
                    onChange={(changes) => saveSystemDetails(changes as SystemDetails)}

                /> : null}
        </SettingsCol>
    </>;
};

export default MainSettings;
